/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { Component } from "react";
import { Modal, Select, Popover, Button, Input, Tooltip } from "antd";
import networkList from "../../../constants/networkList";
import postService from "../../../services/httpService";
import moment from "moment";
import userTrackService from "../../../services/usertrack-service";
import Storage from "../../../services/local-store";
import patientIcon from "../../../assets/images/Patient.svg";
import userIcon from "../../../assets/images/user_color.svg";
import service from "../../../assets/images/service.svg";
import { UserOutlined } from '@ant-design/icons';
import { InfoCircleOutlined } from '@ant-design/icons';
import { ClockCircleOutlined } from '@ant-design/icons';
import { PhoneOutlined } from '@ant-design/icons';
import {socket} from './../Assign/index';

var p=[];

class OperatorCard extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(),
      popupclicked: false,
      visible: false,
      error: null,
      appointmentToken: null,
      appointments: {},
      showapp: false,
      vitalsModalvisible: false,
      vitalsRequired: "",
      confirmLoading: false,
      roomnamefromOperator: "",
      ModalError: false,
      patientids:[],
      patientMoveToQueue:false,
      QueuesList:"",
      value:true
      
     

    };
    
  }

  componentDidMount() {
    p.push(this.props.item.id);
    this.getAppointmentsbyid.bind(this);
  }
  componentDidUpdate() {
    this.assignAppointment.bind(this);
  }

  vitalsModalvisible = (value, roomname) => {

    this.setState({
      vitalsModalvisible: value,
      roomnamefromOperator: roomname,
    });
 };
  vitalshandleOk = () => {
    this.setState({
      confirmLoading: false,
      vitalsModalvisible: false,
    });
  };
  vitalshandleCancel = () => {
    this.setState({
      vitalsModalvisible: false,
    });
  };
  vitalshandleOKCancel = () => {
    this.state.vitalsRequired === "YES" || this.state.vitalsRequired === "NO"
      ? this.setState({
          vitalsModalvisible: false,
          ModalError: false,
        })
      : this.setState({
          ModalError: true,
        });
  };
  // vitalsCheckandassignRoom() {
  //   console.log("vitalsCheckandassignRoom", this.state.vitalsRequired);
  //   // this.props.item.
  //   // this.state.vitalsRequired === "NO" && this.assignRoom();
  // }
  // isVitalsRequired(option, id) {
  //   let yesOrNo = option;
//   isVitalsRequired(option, id,value) {
//     let yesOrNo = option;
//     let patientId = id;
//     this.setState({ vitalsRequired: yesOrNo, vitalsModalvisible: false });
//     console.log("-==-=-==--=-=-=-=-=-=-=-=-==",this.state.roomnamefromOperator);
//     console.log("automove",value,patientId);
   
// // this.setState(patientMoveToQueue = patientMoveToQueue1);
//    if (yesOrNo === "NO" || yesOrNo === "YES"){
//     this.setState({ value:false });
//       this.assignRoom(value);}
//     if(this.state.value==true){  
//     let obj = {
//       data: {
//         patient_id: patientId,
//         is_vitals_required: yesOrNo,
//       },
//     };
//     postService("setPatientVitalsFlag", "POST", obj).then((res) =>
//       console.log("setPatientVitalsFlag", res)
//     );}
//   }
 isVitalsRequired(option, id, value) {
  let yesOrNo = option;
  let patientId = id;

  this.setState({ vitalsRequired: yesOrNo, vitalsModalvisible: false });
  if (yesOrNo === "NO" || yesOrNo === "YES") {
   
       this.assignRoom(value);
  }

  // console.log("automove1", value, patientId,this.state.value);

  let obj = {
      data: {
          patient_id: patientId,
          is_vitals_required: yesOrNo,
      },
  };

  try {
      const res =  postService("setPatientVitalsFlag", "POST", obj);
    
  } catch (error) {
      console.error('Error in setPatientVitalsFlag postService:', error);
  }
}

  assignRoomForOPDorRadiology(value) {
    this.setState({value:false});
  
    let QueueList = this.props.props.QueueList || [];
    var vitalsrequired='';
    // console.log("@@@@@@@@@@@@@QueueList",QueueList,typeof value,value);
    const newArray = [...this.state.patientids];
    newArray.push(this.props.item.id);
    this.setState({ patientids: newArray });
    QueueList.forEach((item1) => {
      if(item1.roomnumber===value){
        if(item1.vitals_required!=null && (item1.vitals_required!=false || vitalsrequired==undefined) ){
          vitalsrequired=true
        }
        else{
        vitalsrequired=item1.vitals_required;}
      }
    });
  // value is Q name
    this.props.QType === "Radiology" && this.assignRoom(value);

    if (this.props.QType === "OPD Consultation") {
      this.vitalsModalvisible(true,value);
      this.setState({
        roomnamefromOperator: value,
        vitalsModalvisible: true,
        
      });
      let option=null;
                if(vitalsrequired){
                  option="YES"
                }
                else{
                  option="NO"
                }
                this.isVitalsRequired(
            
                  // item.id //patient card
                  option,this.props.item.id,value
                );
    }
  }

  // this.state.vitalsRequired === "NO" && this.assignRoom(value);

  assignRoom(value) {
    if (value !== undefined && value !== null) {
      let currentObj = this.props.item;
      let QueueList = this.props.props.QueueList || [];
      //QueueList=QueueList.filter(s => s.display_status != '1');
      QueueList.forEach((item1) => {
        if (item1.roomnumber === value) {
          item1.patients = [...item1.patients, currentObj];
          let obj = {
            patientId: currentObj.id,
            queueListId: item1.queuelistid,
          };
          this.props.activateLoader();
          let Userlogobj = {
            user: JSON.parse(Storage.get("user")),
            action: "Assign patient from dropdown",
            date: new Date(),
            meta: obj,
          };
          userTrackService(Userlogobj);
          postService("assignPatientToRoom", "POST", { data: obj }).then(
            (res) => {
              let Userlogobjres = {
                user: JSON.parse(Storage.get("user")),
                action: "Assign patient from dropdown - response",
                date: new Date(),
                meta: res,
              };
              userTrackService(Userlogobjres);
              //if (res) {
              //  this.props.deActivateLoader();
              if (socket.readyState === WebSocket.OPEN) {
                console.log('WebSocket connection established Checkin Checkin.');
                // this.onStartQ(queueitem, "withoutassign")
                const jsonString = JSON.stringify({data:"assign"});
                socket.send(jsonString);
              };
              //this.props.refreshData();
              //this.props.refreshMultipleQueues(obj, "assign");
              this.setState({value:true});
              //}
            }
          );
        }
      });
    }
  }
//   assignRoom(value) {
//     return new Promise((resolve, reject) => {
//         if (value !== undefined && value !== null) {
//             let currentObj = this.props.item;
//             let QueueList = this.props.props.QueueList || [];

//             QueueList.forEach((item1) => {
//                 if (item1.roomnumber === value) {
//                     item1.patients = [...item1.patients, currentObj];
//                     let obj = {
//                         patientId: currentObj.id,
//                         queueListId: item1.queuelistid,
//                         abovePatientId: "",
//                         belowPatientId: "",
//                     };
//                     this.props.activateLoader();
//                     let Userlogobj = {
//                         user: JSON.parse(Storage.get("user")),
//                         action: "Assign patient from dropdown",
//                         date: new Date(),
//                         meta: obj,
//                     };
//                     userTrackService(Userlogobj);
                   
//                     // console.log("automovep",currentObj.id,this.state.value);
//                     postService("assignPatientToRoom", "POST", { data: obj }).then(
//                         (res) => {
//                             let Userlogobjres = {
//                                 user: JSON.parse(Storage.get("user")),
//                                 action: "Assign patient from dropdown - response",
//                                 date: new Date(),
//                                 meta: res,
//                             };
//                             userTrackService(Userlogobjres);
//                             this.props.refreshData();
//                             this.props.refreshMultipleQueues(obj, "assign");
//                             this.setState({value:true})
                            

//                             resolve();  // Resolve the promise when done
//                         }
//                     ).catch((error) => {
//                         console.error('Error in assignRoom postService:', error);
//                         reject(error);  // Reject the promise in case of error
//                     });
//                 }
//             });
//         } else {
//             resolve();  // Resolve immediately if value is undefined or null
//         }
//     });
// }

  assignRoomForCTA(value) {
    let currentObj = this.props.item;
    let QueueList = this.props.props.QueueList || [];
    //QueueList=QueueList.filter(s => s.display_status != '1');
    QueueList.forEach((item1) => {
      item1.patients = [...item1.patients, currentObj];
      let obj = {
        patientId: currentObj.id,
        queueListId: item1.queuelistid,
      };
      let Userlogobj = {
        user: JSON.parse(Storage.get("user")),
        action: "Assign patient from CTA",
        date: new Date(),
        meta: obj,
      };
      userTrackService(Userlogobj);
      postService("assignPatientToRoom", "POST", { data: obj }).then((res) => {
        let Userlogobjres = {
          user: JSON.parse(Storage.get("user")),
          action: "Assign patient from CTA - response",
          date: new Date(),
          meta: res,
        };
        userTrackService(Userlogobjres);
        if (res) {
          // this
          //     .props
          //     .refreshData();
          this.props.refreshMultipleQueues(obj, "assign");
        }
      });
    });
  }
  removePatient() {
    
    let currentObj = this.props.item;
    let patientId = currentObj.id || "";
    

    let obj = {
      patient_id: patientId,
    };
    let Userlogobj = {
      user: JSON.parse(Storage.get("user")),
      action: "Remove patient from new list",
      date: new Date(),
      meta: obj,
    };
    userTrackService(Userlogobj);
    postService("removePatientFromPatientsList", "POST", { data: obj }).then(
      (res) => {
        let Userlogobjres = {
          user: JSON.parse(Storage.get("user")),
          action: "Remove patient from new list - response",
          date: new Date(),
          meta: res,
        };
        userTrackService(Userlogobjres);
        if (res) {
          if (socket.readyState === WebSocket.OPEN) {
            console.log('WebSocket connection established Checkin Checkin.');
            // this.onStartQ(queueitem, "withoutassign")
            const jsonString = JSON.stringify({data:"remove"});
            socket.send(jsonString);
          };
          //this.props.refreshData();
        }
      }
    );
    this.hide();
  }
  hide = () => {
    this.setState({ popupclicked: false });
  };
  prepareRoomsData() {
    

    let QueueList = this.props.props.QueueList || [];
    //QueueList=QueueList.filter(s => s.display_status != '1');
  let roomNumbers = [];
    let item = this.props.item;

    let startDate = moment(new Date(item.appointment_date));
    let endDate = moment(new Date());
    startDate = moment(startDate).format("YYYY-MM-DD");
    endDate = moment(endDate).format("YYYY-MM-DD");
    let appointmentSameValid = moment(startDate).isSame(endDate);
    // console.log("QQQQQQQQUUUUUUUUUUUUUUEEEEEEEE",QueueList);

    QueueList.map((data, index) => {
      // console.log("QueueList data", data);
      // console.log("QueueList item", item);
      if (
        (!item.appointment_date || appointmentSameValid) &&
        item.service_groupid
      ) {
        if (data.service_groups.length > 0) {
          // if (item.service_group_name !== undefined & item.service_group_name !== null && data.service_group_name !== undefined && data.service_group_name !== null) {
          //     if (item.service_group_name === data.service_group_name) {
          //         roomNumbers.push({ "roomNumber": data.roomnumber })
          //     }
          // }

          if (this.props.QType === "Radiology") {
            if (data.service_groups.includes(item.service_groupid)) {
              roomNumbers.push({ roomNumber: data.roomnumber });
            }
          }

          if (this.props.QType === "OPD Consultation") {
            if (data.service_groups.includes(item.service_groupid)) {
              if (data.queue_doctor_id === item.service_id) {
                roomNumbers.push({ roomNumber: data.roomnumber });
              }
            }
          }
        }
      }
    });
    return roomNumbers;
  }
  handleClickChange = (visible) => {
    this.setState({ popupclicked: visible });
  };
  sug(item) {
    this.props.setLatestCard(item, this.props.roomId);
  }
  handleCancel() {
    this.setState({ visible: false });
  }

  keypressevent = (e) => {
    if (e.key === "Enter") {
      var value = e.target.value;
      if (e.target.value !== null) {
        this.setState(
          (state) => ({ appointmentToken: value }),
          () => {
            this.checkAppointmentToken();
          }
        );
      }
    }
  };

  blurEvent = (e) => {
    this.setState((state) => ({ error: null }));
    var value = e.target.value;
  
    this.setState((state) => ({ appointmentToken: value }));
    if (value === null || value === "" || value.length === 0) {
      this.setState((state) => ({ error: "Please Enter Appointment Token" }));
    }
  };

  checkAppointmentToken() {
    let currentObj = this.props.item;
    this.setState((state) => ({ error: null }));
    if (
      this.state.appointmentToken !== null &&
      this.state.appointmentToken !== ""
    ) {
      const { CheckAppointmentToken } = networkList;
      var payload = {
        patientId: currentObj.id,
        appointmentToken: this.state.appointmentToken,
      };
      let Userlogobj = {
        user: JSON.parse(Storage.get("user")),
        action: "Link appointment manually",
        date: new Date(),
        meta: payload,
      };
      userTrackService(Userlogobj);
      postService(CheckAppointmentToken, "POST", { data: payload }).then(
        (res) => {
          let Userlogobjres = {
            user: JSON.parse(Storage.get("user")),
            action: "Link appointment manually - response",
            date: new Date(),
            meta: res,
          };
          userTrackService(Userlogobjres);
          var This = this;
          if (res.status) {
            if (socket.readyState === WebSocket.OPEN) {
              console.log('WebSocket connection established Checkin Checkin.');
              // this.onStartQ(queueitem, "withoutassign")
              const jsonString = JSON.stringify({data:"assign"});
              socket.send(jsonString);
            };
            //this.props.refreshData();
            Modal.success({
              maskClosable: false,
              zIndex: 1040,
              title: "success message",
              content: "Appointment linked Sucessfully",
              onOk() {
                This.setState({ visible: false });
              },
            });
          } else {
            Modal.error({
              maskClosable: false,
              zIndex: 1040,
              title: "Error",
              content: "" + res.data + "",
            });
          }
        }
      );
    } else {
      this.setState((state) => ({ error: "Please Enter Appointment Token" }));
    }
  }

  renderTime(date) {
    return moment(date).format("hh:mm a");
  }

  renderDate(date) {
    return moment(date).format("MMM Do, YY");
  }

  getAppointmentsbyid(e) {
    if (e) {
      let item = this.props.item;
      let patient_id = item.id;
      let obj = { patientId: patient_id };
      postService("getAppointmentsByPatientId", "POST", { data: obj }).then(
        (res) => {
          if (res.status) {
            this.setState({ appointments: res.data });
          }
        }
      );
    }
  }
  assignAppointment(e) {
    if (e) {
      let { appointment_id, appointment_date, start_time } = e;
      let item = this.props.item;
      let { id, billnumber } = item;
      let obj = {
        patient_id: id,
        appointment_date: appointment_date,
        appointment_id: appointment_id,
        bill_no: billnumber,
        start_time: start_time,
      };
      //console.log(obj);
      postService("mapSelectedAppointment", "POST", { data: obj }).then(
        (res) => {
          if (res.status) {
            if (socket.readyState === WebSocket.OPEN) {
              console.log('WebSocket connection established Checkin Checkin.');
              // this.onStartQ(queueitem, "withoutassign")
              const jsonString = JSON.stringify({data:"assign"});
              socket.send(jsonString);
            };
           // this.props.refreshData();
          }
        }
      );
    }
  }
  removeAppointment() {
    let item = this.props.item;
    let { id } = item;
    let obj = { patient_id: id };
    postService("unlinkSelectedAppointment", "POST", { data: obj }).then(
      (res) => {
        if (res.status) {
          if (socket.readyState === WebSocket.OPEN) {
            console.log('WebSocket connection established Checkin Checkin.');
            // this.onStartQ(queueitem, "withoutassign")
            const jsonString = JSON.stringify({data:"assign"});
            socket.send(jsonString);
          };
          //this.props.refreshData();
        }
      }
    );
  }

  render() {
    // console.log("6666666666666666",p);
  
    const qList = this.props.props.QueueList;
    const item = this.props.item;
    const Option = Select.Option;
   
    const rooms = this.prepareRoomsData();

    // console.log("-----------------rooms------------",rooms);
    let draggableStatus, appointmentValid, appointmentSameValid;
    let appointment_date = item.appointment_date;
    // console.log("item", item);

    let vitalsOptions = ["YES", "NO"];
    
    

    if(this.props.QType === "Radiology"){if (
      appointment_date !== undefined &&
      appointment_date !== null &&
      appointment_date !== ""
    ) {
      let startDate = moment(new Date(appointment_date));
      let endDate = moment(new Date());
      startDate = moment(startDate).format("YYYY-MM-DD");
      endDate = moment(endDate).format("YYYY-MM-DD");
      appointmentValid = moment(startDate).isAfter(endDate);
      appointmentSameValid = moment(startDate).isSame(endDate);
      // console.log("startDate", startDate);
      // console.log("endDate", endDate);
      // console.log("appointmentValid", appointmentValid);
      // console.log("appointmentSameValid", appointmentSameValid);
      if (
        // item.has_appointment === "1" && (appointmentValid == true || appointmentSameValid == true)
        item.has_appointment === "1" &&
        appointmentSameValid == true
      ) {
        draggableStatus = "true";
      } else {
        draggableStatus = "false";
      }
    } else {
      if (item.has_appointment === "1" && !appointment_date)
        draggableStatus = "true";
    }}
    if(this.props.QType === "OPD Consultation"){
      if (
      appointment_date !== undefined &&
      appointment_date !== null &&
      appointment_date !== ""
    ) {
      let startDate = moment(new Date(appointment_date));
      let endDate = moment(new Date());
      startDate = moment(startDate).format("YYYY-MM-DD");
      endDate = moment(endDate).format("YYYY-MM-DD");
      appointmentValid = moment(startDate).isAfter(endDate);
      appointmentSameValid = moment(startDate).isSame(endDate);
      // console.log("startDate", startDate);
      // console.log("endDate", endDate);
      // console.log("appointmentValid", appointmentValid);
      // console.log("appointmentSameValid", appointmentSameValid);
      if (
        // item.has_appointment === "1" && (appointmentValid == true || appointmentSameValid == true)
        item.has_appointment === "1" &&
        appointmentSameValid == true
      ) {
        draggableStatus = "true";
      } else {
        draggableStatus = "false";
      }
    } else {
      if (item.has_appointment === null && !appointment_date){
      // if ((item.has_appointment === null || item.has_appointment !== "1") && !appointment_date)
        draggableStatus = "true";
    }
  }}

    const patient_details = (
      <div>
        <p className="mb-0">
          Service Group :{" "}
          {item.service_group_name ? item.service_group_name : "--"}
        </p>
        <p className="mb-0">
          Service : {item.service_name ? item.service_name : "--"}
        </p>
        <p className="mb-0">
          Mobile No : {item.phonenumber ? item.phonenumber : "--"}
        </p>
        {/* <p className="mb-0 text-capitalize">
          Emergency : {item.is_emergency ? item.is_emergency : "--"}
        </p>
        <p className="mb-0 text-capitalize">
          Arrived : {item.is_patient_arrival ? item.is_patient_arrival : "--"}
        </p> */}
      </div>
    );
    const appointment_details = (
      <div>
        <p className="mb-0">
          Service Group :{" "}
          {item.service_group_name ? item.service_group_name : "--"}
        </p>
        <p className="mb-0">
          Service : {item.doctor_name ? item.doctor_name : "--"}
        </p>
        <p className="mb-0">
          Mobile No : {item.phonenumber ? item.phonenumber : "--"}
        </p>
        {/* <p className="mb-0 text-capitalize">
          Emergency : {item.is_emergency ? item.is_emergency : "--"}
        </p>
        <p className="mb-0 text-capitalize">
          Arrived : {item.is_patient_arrival ? item.is_patient_arrival : "--"}
        </p> */}
      </div>
    );
    const popupContent = (
      <div className="popup">
        <h4>
          More Options 
          <img
            onClick={this.hide}
            src="/assets/images/icons/popup-close.png"
            alt="closeicon"
          />
        </h4>
        <div className="row">
          <div className="col">
            <Button
              className="btn-red mx-0"
              onClick={this.removePatient.bind(this)}
            >
              Remove 
            </Button>
          </div>
        </div>
      </div>
    );
    
    const c=p.filter(item1 => item1 === item.id).length;
// console.log("0000000000000000000",c,item.id);
    return (
      
      this.props.datavalue === "true"?(
      <React.Fragment>
      {/* {rooms.length==1 ?(this.assignRoomForOPDorRadiology(rooms[0].roomNumber)):( */}
         
     
      <div
        class="pl-2 pr-1 py-1 my-2 mr-1 b-card-body disable-text"
        draggable={draggableStatus}
        onDragStart={this.sug.bind(this, item)}
      >
        <div className="row col">
          {/* {this.props.QType === "Radiology" &&
            (appointmentValid == false && appointmentSameValid == false ? (
              <small className="text-danger">
                Appointment is not for today
              </small>
            ) : !appointment_date ? (
              <small className="text-danger">No Appointment</small>
            ) : (
              rooms.length === 0 && (
                <small className="text-danger">Room not matched</small>
              )
            ))} */}
          {/* {this.props.QType === "OPD Consultation" && 
          appointmentValid == false && appointmentSameValid == false ? 
            <small className="text-danger">
              Appointment is not for today
            </small> : 
          rooms.length === 0 && (
            <small className="text-danger">Doctor not matched</small>
          )} */}
        </div>
        <div className="row">
          <div class="col-8">
            <div className="row">
              {/* patient name */}
              <p className="text-p-light col-12 pl-1">
                <img
                  alt=""
                  src={patientIcon}
                  class="patientIcon"
                  draggable={false}
                />
                {item.name}
              </p>
              {/* patient details, umr */}
              <p className="text-p-light col-12">
                <Popover
                  overlayClassName="popover-custom"
                  content={appointment_details}
                  title=""
                >
                  {/* <Icon
                    type="info-circle"
                    style={{
                      color: "#ac7ab0",
                      transform: "rotate(0deg)",
                      fontSize: "15px",
                      margin: "0 6px 0 -2px",
                    }}
                    draggable={draggableStatus}
                  /> */}
                  <ClockCircleOutlined
style={{
  color: "#ac7ab0",
  transform: "rotate(0deg)",
  fontSize: "15px",
  marginRight: "6px",
}}
/>
                </Popover>
                <span>{item.umr ? item.umr : "--"}</span>
               
              </p>
            </div>
          </div>
          {/* <div className="col-4 pl-0 my-auto">          
            {rooms.length > 0 ? (
              <Select
                value={null}
                placeholder="Room"
                onChange={this.assignRoomForOPDorRadiology.bind(this)}
                dropdownMatchSelectWidth={false}
                style={{
                  width: "100%",
                }}
              >
                {rooms.map((q) => (
                  <Option value={q.roomNumber}>{q.roomNumber}</Option>
                ))}
              </Select>
            ) : (
              <Select
                value={null}
                placeholder="Room"
                style={{
                  width: "100%",
                }}
                onChange={this.assignRoomForOPDorRadiology.bind(this)}
                dropdownMatchSelectWidth={false}
              />
            )}
          </div> */}
        </div>
        <div className="row">
          <p className="text-p-light col-12 mt-1 service-in-card">
          <PhoneOutlined
  style={{
    color: "#ac7ab0",
    transform: "rotate(0deg)",
    fontSize: "15px",
    marginRight: "6px",
    marginBottom: "0",
  }}
/>
            {item.phonenumber ? item.phonenumber : "--"}
          </p>
        </div>
        <div className="row  mt-1">
          <div class="col-10">
            <div className="row">
              <div className="col-4">
                <p className="text-p-light f-12 text-uppercase">
                  <img
                    alt=""
                    src={service}
                    draggable={false}
                    className="uidIcon"
                  />
                  {item.casetype ? item.casetype : "--"}
                </p>
              </div>
              <div className="col-8">
                {item.has_appointment === "1" ? (
                  <p className="text-p-light f-12 operator-service-app-p">
                    {/* <img
                      src="/assets/images/icons/appointment-icon-dark.png"
                      alt="appointmeny"
                      draggable={draggableStatus}
                    /> */}
                    {/* <Icon
                      type="clock-circle"
                      style={{
                        color: "#ac7ab0",
                        transform: "rotate(0deg)",
                        fontSize: "15px",
                        margin: "0 6px 0 0",
                      }}
                    /> */}
                    <ClockCircleOutlined
style={{
  color: "#ac7ab0",
  transform: "rotate(0deg)",
  fontSize: "15px",
  marginRight: "6px",
  marginBottom: "0",
}}
/>
                    {item.appointment_date
                      ? this.renderTime(item.appointment_date)
                      : "--"}
                  </p>
                ):
                <p  className="text-p-light f-12 operator-service-app-p">
                {/* <Icon
                  type="clock-circle"
                  style={{
                    color: "#ac7ab0",
                    transform: "rotate(0deg)",
                    fontSize: "15px",
                    margin: "0 6px 0 0",
                  }}
                /> */}
                <ClockCircleOutlined
style={{
  color: "#ac7ab0",
  transform: "rotate(0deg)",
  fontSize: "15px",
  margin: "0 6px 0 0",
  
 
}}
/>
                {item.appointment_date.split(" ")[1]}
              </p>
                }

                {/* {item.has_appointment === "1" ? (
                  <p className="text-p-light f-12 operator-service-app-p">
                    <img
                      src="/assets/images/icons/appointment-icon-dark.png"
                      alt="appointmeny"
                      draggable={draggableStatus}
                    />
                    {`${this.renderTime(item.appointment_date)}`}{" "}
                    <img
                      src="/assets/images/icons/delete.png"
                      alt="appointmeny"
                      className="remove-icon-app"
                      onClick={this.removeAppointment.bind(this)}
                    />
                  </p>
                ) : (
                  <>
                    {appointments.map((d, i) => {
                      console.log("appointments", appointments);
                      console.log("appointments d", d);
                      return (
                        <span className="appt">Appt: {d.start_time}</span>
                      );
                    })}
                  </>
                  ///////////////////
                  // <Select
                  //   value={null}
                  //   placeholder="Appointment"
                  //   style={{
                  //     width: "100%",
                  //   }}
                  //   onDropdownVisibleChange={this.getAppointmentsbyid.bind(
                  //     this
                  //   )}
                  //   onChange={this.assignAppointment.bind(this)}
                  //   dropdownMatchSelectWidth={false}
                  // >
                  //   {appointments.map((d, i) => {
                  //     console.log("appointments", appointments);
                  //     console.log("appointments d", d);
                  //     return (
                  //       <Option value={d} key={i}>
                  //         {d.start_time},{d.service_name}
                  //       </Option>
                  //     );
                  //   })}
                  // </Select>
                )} */}
              </div>
            </div>
          </div>
          {/* <div className="col-2 my-auto">
            
            <p className="text-right text-p-bold">
               asd3 
              <Popover
                placement="bottomLeft"
                content={popupContent}
                trigger="click"
                visible={this.state.popupclicked}
                onVisibleChange={this.handleClickChange}
              >
                <img
                  src="/assets/images/icons/more-icon.png"
                  alt="more"
                  srcset=""
                  draggable={false}
                />
              </Popover>
            </p>
          </div> */}
        </div>
      </div> 
      <Modal
        visible={this.state.visible}
        onCancel={this.handleCancel.bind(this)}
        footer={null}
        maskClosable={false}
        destroyOnClose={true}
      >
        <div className="mx-3 my-0 p-2 k-modal">
          <div className="row">
            <div className="col-12 mb-3">
              <h2 className="text-center">Link Appointement</h2>
            </div>
            <div className="col-12 mb-3">
              <Input
                onBlur={this.blurEvent.bind(this)}
                onKeyPress={this.keypressevent.bind(this)}
                placeholder="Appointment Token"
                prefix={
                  // <Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />
                  <UserOutlined style={{ color: "rgba(0,0,0,.25)" }} />
                }
                suffix={
                  <Tooltip title="Token Number">
                    {/* <Icon
                      type="info-circle"
                      style={{
                        color: "rgba(0,0,0,.45)",
                      }}
                    /> */}
                    <InfoCircleOutlined style={{ color: "rgba(0,0,0,.45)" }} />
                    {" "}
                  </Tooltip>
                }
              />
              <small className="text-danger">{this.state.error}</small>
            </div>
            <div className="col-12 text-center mt-3">
              <Button
                className="btn-dark-gray"
                onClick={this.checkAppointmentToken.bind(this)}
              >
                Check
              </Button>
              <Button
                className="btn-dark-red"
                onClick={this.handleCancel.bind(this)}
              >
                Cancel
              </Button>
            </div>
          </div>
        </div>
      </Modal>
      {/* Vitals */}
      {/* <Modal
        visible={this.state.vitalsModalvisible}
        onOk={this.vitalshandleOKCancel}
        confirmLoading={this.state.confirmLoading}
        onCancel={this.vitalshandleOKCancel}
        footer={null}
      >
        <p>Required to measure vitals?</p>
        <div className="col-12 mb-3 text-center">
          {this.state.ModalError && (
            <small className="text-danger">Please select YES or NO.</small>
          )}
          {vitalsOptions.map((option) => (
            <Button
              className={`mx-4 ${option === "YES" && "btn-magenta"}`}
              id={option}
              value={option}
              type={option === "YES" && "primary"}
              onClick={(e) =>
                this.isVitalsRequired(
                  option,
                  item.id
                  // this.state.roomnamefromOperator
                )
              }
            >
             
              {option}{item.id}
            </Button>
          ))}
        </div>
      </Modal>  */}
      
    </React.Fragment>):
      
     ( <React.Fragment>
        {/* {rooms.length==1 ?(this.assignRoomForOPDorRadiology(rooms[0].roomNumber)):( */}
           {/* {!this.state.patientids.includes(item.id) && !item.move_to_queue && rooms.length==1 ?(this.assignRoomForOPDorRadiology(rooms[0].roomNumber)):(
        */}

         {/* {!this.state.patientids.includes(item.id) && !item.move_to_queue  ?(this.assignRoomForOPDorRadiology(rooms[0].roomNumber)):( */}
       
        <div
          class="pl-2 pr-1 py-1 my-2 mr-1 b-card-body disable-text"
          draggable={draggableStatus}
          onDragStart={this.sug.bind(this, item)}
        >
          <div className="row col">
            {this.props.QType === "Radiology" &&
              (appointmentValid == false && appointmentSameValid == false ? (
                <small className="text-danger">
                  Appointment is not for today
                </small>
              ) : !appointment_date ? (
                <small className="text-danger">No Appointment</small>
              ) : (
                rooms.length === 0 && (
                  <small className="text-danger">Room not matched</small>
                )
              ))}
            {this.props.QType === "OPD Consultation" && 
            appointmentValid == false && appointmentSameValid == false ? 
              <small className="text-danger">
                Appointment is not for today
              </small> : 
            rooms.length === 0 && (
              <small className="text-danger">Doctor not matched</small>
            )}
          </div>
          <div className="row">
            <div class="col-8">
              <div className="row">
                {/* patient name */}
                <p className="text-p-light col-12 pl-1">
                  <img
                    alt=""
                    src={patientIcon}
                    class="patientIcon"
                    draggable={false}
                  />
                  {item.name}
                </p>
                {/* patient details, umr */}
                <p className="text-p-light col-12">
                  <Popover
                    overlayClassName="popover-custom"
                    content={patient_details}
                    title=""
                  >
                    {/* <Icon
                      type="info-circle"
                      style={{
                        color: "#ac7ab0",
                        transform: "rotate(0deg)",
                        fontSize: "15px",
                        margin: "0 6px 0 -2px",
                      }}
                      draggable={draggableStatus}
                    /> */}
                    <ClockCircleOutlined
  style={{
    color: "#ac7ab0",
    transform: "rotate(0deg)",
    fontSize: "15px",
    marginRight: "6px",
  }}
/>
                  </Popover>
                  <span>{item.umr ? item.umr : "--"}</span>
                </p>
              </div>
            </div>
            <div className="col-4 pl-0 my-auto">          
              {rooms.length > 0 ? (
                <Select
                  value={null}
                  placeholder="Room"
                  onChange={this.assignRoomForOPDorRadiology.bind(this)}
                  dropdownMatchSelectWidth={false}
                  style={{
                    width: "100%",
                  }}
                >
                  {rooms.map((q) => (
                    <Option value={q.roomNumber}>{q.roomNumber}</Option>
                  ))}
                </Select>
              ) : (
                <Select
                  value={null}
                  placeholder="Room"
                  style={{
                    width: "100%",
                  }}
                  onChange={this.assignRoomForOPDorRadiology.bind(this)}
                  dropdownMatchSelectWidth={false}
                />
              )}
            </div>
          </div>
          <div className="row">
            <p className="text-p-light col-12 mt-1 service-in-card">
              <img
                alt=""
                src={userIcon}
                className="uidIcon"
                draggable={false}
              />
              {item.service_name ? item.service_name : "--"}
            </p>
          </div>
          <div className="row  mt-1">
            <div class="col-10">
              <div className="row">
                <div className="col-4">
                  <p className="text-p-light f-12 text-uppercase">
                    <img
                      alt=""
                      src={service}
                      draggable={false}
                      className="uidIcon"
                    />
                    {item.patienttype ? item.patienttype : "--"}
                  </p>
                </div>
                <div className="col-8">
                  {item.has_appointment === "1" ? (
                    <p className="text-p-light f-12 operator-service-app-p">
                      {/* <img
                        src="/assets/images/icons/appointment-icon-dark.png"
                        alt="appointmeny"
                        draggable={draggableStatus}
                      /> */}
                      {/* <Icon
                        type="clock-circle"
                        style={{
                          color: "#ac7ab0",
                          transform: "rotate(0deg)",
                          fontSize: "15px",
                          margin: "0 6px 0 0",
                        }}
                      /> */}
                      <ClockCircleOutlined
  style={{
    color: "#ac7ab0",
    transform: "rotate(0deg)",
    fontSize: "15px",
    marginRight: "6px",
    marginBottom: "0",
  }}
/>
                      {item.appointment_date
                        ? this.renderTime(item.appointment_date)
                        : "--"}
                    </p>
                  ):
                  <p className="text-p-light f-12 operator-service-app-p">
                  {/* <Icon
                    type="clock-circle"
                    style={{
                      color: "#ac7ab0",
                      transform: "rotate(0deg)",
                      fontSize: "15px",
                      margin: "0 6px 0 0",
                    }}
                  /> */}
                  <ClockCircleOutlined
  style={{
    color: "#ac7ab0",
    transform: "rotate(0deg)",
    fontSize: "15px",
    margin: "0 6px 0 0",
  }}
/>
                  Walk-in
                </p>
                  }

                  {/* {item.has_appointment === "1" ? (
                    <p className="text-p-light f-12 operator-service-app-p">
                      <img
                        src="/assets/images/icons/appointment-icon-dark.png"
                        alt="appointmeny"
                        draggable={draggableStatus}
                      />
                      {`${this.renderTime(item.appointment_date)}`}{" "}
                      <img
                        src="/assets/images/icons/delete.png"
                        alt="appointmeny"
                        className="remove-icon-app"
                        onClick={this.removeAppointment.bind(this)}
                      />
                    </p>
                  ) : (
                    <>
                      {appointments.map((d, i) => {
                        console.log("appointments", appointments);
                        console.log("appointments d", d);
                        return (
                          <span className="appt">Appt: {d.start_time}</span>
                        );
                      })}
                    </>
                    ///////////////////
                    // <Select
                    //   value={null}
                    //   placeholder="Appointment"
                    //   style={{
                    //     width: "100%",
                    //   }}
                    //   onDropdownVisibleChange={this.getAppointmentsbyid.bind(
                    //     this
                    //   )}
                    //   onChange={this.assignAppointment.bind(this)}
                    //   dropdownMatchSelectWidth={false}
                    // >
                    //   {appointments.map((d, i) => {
                    //     console.log("appointments", appointments);
                    //     console.log("appointments d", d);
                    //     return (
                    //       <Option value={d} key={i}>
                    //         {d.start_time},{d.service_name}
                    //       </Option>
                    //     );
                    //   })}
                    // </Select>
                  )} */}
                </div>
              </div>
            </div>
            <div className="col-2 my-auto">
              
              <p className="text-right text-p-bold">
                {/* asd3 */}
                <Popover
                  placement="bottomLeft"
                  content={popupContent}
                  trigger="click"
                  visible={this.state.popupclicked}
                  onVisibleChange={this.handleClickChange}
                >
                  <img
                    src="/assets/images/icons/more-icon.png"
                    alt="more"
                    srcset=""
                    draggable={false}
                  />
                </Popover>
              </p>
            </div>
          </div>
        </div> 
        <Modal
          visible={this.state.visible}
          onCancel={this.handleCancel.bind(this)}
          footer={null}
          maskClosable={false}
          destroyOnClose={true}
        >
          <div className="mx-3 my-0 p-2 k-modal">
            <div className="row">
              <div className="col-12 mb-3">
                <h2 className="text-center">Link Appointement</h2>
              </div>
              <div className="col-12 mb-3">
                <Input
                  onBlur={this.blurEvent.bind(this)}
                  onKeyPress={this.keypressevent.bind(this)}
                  placeholder="Appointment Token"
                  prefix={
                    // <Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />
                    <UserOutlined style={{ color: "rgba(0,0,0,.25)" }} />
                  }
                  suffix={
                    <Tooltip title="Token Number">
                      {/* <Icon
                        type="info-circle"
                        style={{
                          color: "rgba(0,0,0,.45)",
                        }}
                      /> */}
                      <InfoCircleOutlined style={{ color: "rgba(0,0,0,.45)" }} />
                      {" "}
                    </Tooltip>
                  }
                />
                <small className="text-danger">{this.state.error}</small>
              </div>
              <div className="col-12 text-center mt-3">
                <Button
                  className="btn-dark-gray"
                  onClick={this.checkAppointmentToken.bind(this)}
                >
                  Check
                </Button>
                <Button
                  className="btn-dark-red"
                  onClick={this.handleCancel.bind(this)}
                >
                  Cancel
                </Button>
              </div>
            </div>
          </div>
        </Modal>
        {/* Vitals */}
        {/* <Modal
          visible={this.state.vitalsModalvisible}
          onOk={this.vitalshandleOKCancel}
          confirmLoading={this.state.confirmLoading}
          onCancel={this.vitalshandleOKCancel}
          footer={null}
        >
          <p>Required to measure vitals?</p>
          <div className="col-12 mb-3 text-center">
            {this.state.ModalError && (
              <small className="text-danger">Please select YES or NO.</small>
            )}
            {vitalsOptions.map((option) => (
              <Button
                className={`mx-4 ${option === "YES" && "btn-magenta"}`}
                id={option}
                value={option}
                type={option === "YES" && "primary"}
                onClick={(e) =>
                  this.isVitalsRequired(
                    option,
                    item.id
                    // this.state.roomnamefromOperator
                  )
                }
              >
               
                {option}{item.id}
              </Button>
            ))}
          </div>
        </Modal>  */}
        
      </React.Fragment>)
    );
  }
}

export default OperatorCard;
